import React from 'react'
import { ResetPlayerPopup as FullscreenVideoPlayerPopup } from '@thriveglobal/thrive-web-leafkit'

export default FullscreenVideoPlayerPopup
